import { useContext } from 'react';
import {
  CommercialCriteriasDefault,
  EstateType,
  ExtraCriterias,
  FarmCriteriasDefault,
} from '../../Enums';
import {
  changeCheckboxAriaAttr,
  getLargeObjectTypeIconPath,
} from '../../helpers';
import { FilterContext, IFilterContext } from '../../filterTools';
import { ITag } from '../../types/interfaces';

export const EstateSelector = (): JSX.Element => {
  const filterContext = useContext(FilterContext);

  function updateEstateTypeTags(estateType?: EstateType) {
    const existingTag = filterContext.tags.some(
      (x) => x.estateType === estateType && x.type === 'estateType'
    );

    //hard coded values below due to unidentified type of alignments
    let currentTags = filterContext.tags;
    let currentVisible: { [key: string]: ITag } = {};
    if (existingTag) {
      const filteredItems = filterContext.tags.filter((x: ITag) => {
        return (
          x.estateType !== estateType &&
          !(
            estateType === EstateType.Agriculture &&
            x.type === 'alignment' &&
            FarmCriteriasDefault.some((t) => t.id === x.id)
          ) &&
          !(
            estateType === EstateType.Commercial &&
            x.type === 'alignment' &&
            CommercialCriteriasDefault.some(
              (t) => t.id === x.id?.replace('-', '/')
            )
          )
        );
      });
      filterContext.setTags(filteredItems);
      currentVisible = updateNewFilterItems(filterContext, filteredItems);
      currentTags = filteredItems;
    } else {
      const newTags = [
        ...filterContext.tags,
        { type: 'estateType', estateType },
      ];
      filterContext.setTags(newTags);
      currentVisible = updateNewFilterItems(filterContext, newTags);
      currentTags = newTags;
    }
    const filteredItems = currentTags.filter((x: ITag) => {
      if (x.type === 'extraCriteria') {
        const isInvisible = typeof currentVisible[x.id ?? ''] !== 'object';
        if (isInvisible) return false;
      }
      return true;
    });
    filterContext.setTags(filteredItems);
  }

  function updateNewFilterItems(
    filterContext: IFilterContext,
    filteredItems: ITag[]
  ): { [key: string]: ITag } {
    const selectedEstateTypesList = filteredItems.map((x) => x.estateType);
    const tArray: { [key: string]: ITag } = {};

    Object.keys(ExtraCriterias).map((x) => {
      const crit = ExtraCriterias[x];
      selectedEstateTypesList.forEach((type) => {
        if (type && crit.belongsTo.includes(type)) {
          tArray[x] = crit as ITag;
        }
      });
    });

    if (filterContext.visibleExtraCrits !== tArray) {
      filterContext.setVisibleExtraCrits(tArray);
    }
    return tArray;
  }
  const hasEstateTypeTag = (estate: EstateType): boolean => {
    return filterContext.tags.some(
      (t) => t.estateType === estate && t.type === 'estateType'
    );
  };
  return (
    <div
      id="object-types"
      className="justify-items-stretch gap-2 sm:gap-3 grid grid-cols-4 md:grid-cols-7 lg:grid-cols-4 my-4 mdplus:mb-4 px-3 lg:px-4 overflow-hidden"
    >
      {Object.entries(EstateType)
        .filter(
          (y) =>
            y[1] !== EstateType.OwnedApartment && y[1] !== EstateType.Premises
        )
        .map(([, estate]) => (
          <label
            key={estate}
            className={`w-full justify-self-center font-icb select-none cursor-pointer py-3 flex flex-col rounded-md ${
              hasEstateTypeTag(estate)
                ? 'bg-blue700 text-white'
                : 'bg-grey50 text-blue700'
            }`}
          >
            <input
              className="hidden"
              tabIndex={0}
              type="checkbox"
              aria-checked="false"
              checked={hasEstateTypeTag(estate)}
              onChange={(e) => {
                updateEstateTypeTags(estate);
                changeCheckboxAriaAttr(e);
              }}
            />
            <img
              width="48"
              height="37"
              className="mx-auto w-11 h-11 self-center"
              src={
                '/Images/Icons/objecttypes/' +
                getLargeObjectTypeIconPath(
                  estate,
                  hasEstateTypeTag(estate) === true ? 'white' : 'blue'
                )
              }
              alt={`Objektstyp ${estate}`}
            />
            <span className="text-center text-xs sm:text-sm">{estate}</span>
          </label>
        ))}
    </div>
  );
};
